import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Route404 from 'App/Router/Route404';
import { AboutNova } from 'Assistant/Chatbot/components';
import { useShowVoiceDisclaimer } from 'Assistant/Chatbot/hooks';
import { useHistory } from 'react-router';
import { GradientBackground, Loader } from '@unmind/design-system';
import { useTheme } from 'styled-components';
import RoutePath from 'App/RoutePath';
import { HelpButton } from 'Assistant/Chatbot/components/Voice/HelpButton';
import useUserEntitlements from 'hooks/useUserEntitlements';
import {
  AcknowledgeButton,
  DisclaimerButtonContainer,
  AcknowledgeButtonText,
  DisclaimerHeaderText,
  PageContainer,
  GoBackButton,
  GoBackButtonText,
  ContentContainer,
  AboutContainer,
  LoadingContainer,
  HelpButtonContainer,
} from './styles';

const LoadingScreen = () => {
  const theme = useTheme();
  const { t: translate } = useTranslation('chatbot');

  return (
    <PageContainer>
      <GradientBackground />
      <LoadingContainer
        aria-label={translate('conversation.loading.a11y_label')}
      >
        <Loader color={theme.colors.text.primary} />
      </LoadingContainer>
    </PageContainer>
  );
};

export function VoiceDisclaimerPage() {
  const { t: translate } = useTranslation('chatbot');
  const { entitlements, loading: entitlementsLoading } = useUserEntitlements();
  const isNovaVoiceEnabled = entitlements?.novaVoice;
  const hasNavigated = useRef(false);
  const history = useHistory();
  const { showVoiceDisclaimer, acknowledge } = useShowVoiceDisclaimer();

  const handleAcknowledgeButtonPress = () => {
    hasNavigated.current = true;
    acknowledge();
    history.replace(RoutePath.Voice);
  };

  const handleGoBackButtonPress = () => {
    history.goBack();
  };

  if (entitlementsLoading) {
    return <LoadingScreen />;
  }

  if (!isNovaVoiceEnabled) {
    return <Route404 />;
  }

  if (!showVoiceDisclaimer && !hasNavigated.current) {
    history.replace(RoutePath.Voice);

    return <LoadingScreen />;
  }

  return (
    <PageContainer>
      <GradientBackground />
      <HelpButtonContainer>
        <HelpButton />
      </HelpButtonContainer>
      <ContentContainer>
        <DisclaimerHeaderText level={1}>
          {translate('voice.disclaimer.header')}
        </DisclaimerHeaderText>
        <AboutContainer>
          <AboutNova inVoiceDisclaimer />
        </AboutContainer>
        <DisclaimerButtonContainer>
          <AcknowledgeButton
            onClick={handleAcknowledgeButtonPress}
            label={
              <AcknowledgeButtonText>
                {translate('voice.disclaimer.acknowledge_button.label')}
              </AcknowledgeButtonText>
            }
          />
          <GoBackButton onClick={handleGoBackButtonPress}>
            <GoBackButtonText>
              {translate('voice.disclaimer.go_back_button.label')}
            </GoBackButtonText>
          </GoBackButton>
        </DisclaimerButtonContainer>
      </ContentContainer>
    </PageContainer>
  );
}
